import {
  GET_SEARCH_CHATS_USER,
  GET_CHAT_USER,
  GET_INVITATION,
  GET_NOTIFICATION,
  GET_POST_TYPE_CHATS,
  GET_NOTIFICATION_COUNT,
  GET_JOIN,
} from "../constants";

export const chatandnotification = (
  state = {
    getnotificationlists: [],
    getnotificationcount: [],
    getjoinlists: [],
    serachallusers: [],
    getposttypechatlist: [],
    getinvitationlists: [],
    getchatuserlists: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_NOTIFICATION:
      return { ...state, getnotificationlists: action.getnotificationlists };
    case GET_NOTIFICATION_COUNT:
      return { ...state, getnotificationcount: action.getnotificationcount };
    case GET_SEARCH_CHATS_USER:
      return { ...state, serachallusers: action.serachallusers };
    case GET_POST_TYPE_CHATS:
      return { ...state, getposttypechatlist: action.getposttypechatlist };
    case GET_INVITATION:
      return { ...state, getinvitationlists: action.getinvitationlists };
    case GET_CHAT_USER:
      return { ...state, getchatuserlists: action.getchatuserlists };
    case GET_JOIN:
      return { ...state, getjoinlists: action.getjoinlists };
    default:
      return state;
  }
};
